module.exports = __webpack_public_path__ + "img/info-security-24.7e01e050.svg";